import Immutable from 'seamless-immutable'
import { createReducer } from 'reduxsauce'

import { Types } from './actions'

export const INITIAL_STATE = Immutable({
  availability: 'notActive',
})

const trackAvailability = (state, action) => state.merge({ availability: action.active ? 'active' : 'notActive' })

const ACTION_HANDLERS = {
  [Types.TRACK_AVAILABILITY]: trackAvailability,
}

export default createReducer(INITIAL_STATE, ACTION_HANDLERS)
